import i18n from './index'
import { initialLanguageArr, i18nConfig } from '@/i18n/config.js'
// import dynamic from 'next/dynamic';

// 系统原有支持的语言
export const langArr = ['en_US', 'zh_TW', 'ko_KP', 'vi_VN', 'tr_TR', 'th_TH', 'es_ES', 'pt_PT']
// 路由语言标识Map，匹配成系统支持的语言格式
export const routerLangMap = {
  'en-US': 'en_US',
  'zh-CN': 'zh_CN',
  'zh-TW': 'zh_TW',
  'vi-VN': 'vi_VN',
  'tr-TR': 'tr_TR',
  'th-TH': 'th_TH',
  'es-ES': 'es_ES',
  'pt-PT': 'pt_PT',
  'ko-KP': 'ko_KP',
}

export const langRouterLangMap = Object.keys(routerLangMap).reduce<Record<string, string>>(
  (acc, cur) => {
    acc[routerLangMap[cur as keyof typeof routerLangMap]] = cur
    return acc
  },
  {},
)

export const isBrowser = () => {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement)
}

export const setLanguage = (lang: string) => {
  if (initialLanguageArr.find((item: any) => item.langValue === lang)) {
    if (isBrowser()) {
      window?.localStorage?.setItem(i18nConfig.langLocalName, lang)
    }
    i18n.changeLanguage(lang)
  } else {
    console.error('lang undefined')
  }
}

export const getLanguage = () => {
  const localLang = isBrowser() ? window?.localStorage?.getItem(i18nConfig.langLocalName) : ''
  return i18n.language || localLang || i18nConfig.defaultLang
}

export const getPathsLangParams = (params?: null | object): { params: { lang: string } }[] => {
  return initialLanguageArr.map((item: any) => {
    return {
      params: {
        ...(params ? params : {}),
        lang: item.langValue,
      },
    }
  })
}
